import { useMutation } from "@tanstack/react-query";
import { anonymizePrompt } from "../services/compass.service";
import type { IAnonymizePromptRequest } from "../types/compass.types";

export const useAnonymizePrompt = () => {
  return useMutation({
    mutationFn: (data: IAnonymizePromptRequest) => anonymizePrompt(data),
  });
};
